import { Router } from '@angular/router';
// Third party packages
import { CookieService } from 'ngx-cookie-service';
// Custom packages
import { AuthService } from 'src/app/modules/auth/auth.service';
import { ConfigService } from 'src/app/shared/services/config.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "../../modules/auth/auth.service";
import * as i3 from "ngx-cookie-service";
import * as i4 from "../services/config.service";
var RoleGuard = /** @class */ (function () {
    function RoleGuard(router, authService, cookieService, configService) {
        this.router = router;
        this.authService = authService;
        this.cookieService = cookieService;
        this.configService = configService;
    }
    /**
     * CanActivete method
     * check if user is logged in (in our authService) and if
     * he has an allowed role.
     * Allowed roles must be passed as array in the routing module
     * with `data: { roles ['admin', 'operator', 'adc', 'cdc', 'cdc'] }
     *
     * @see https://stackoverflow.com/questions/42719445/pass-parameter-into-route-guard
     *
     * @since 1.0.0
     *
     * @returns boolean true if user is allowed, false and redirect otherwhise
     */
    RoleGuard.prototype.canActivate = function (route, state) {
        this.loggedUser = this.authService.loggedUser$.value;
        this.loggedUserPermissions = this.authService.loggedUserPermissions$.value;
        this.lang = this.cookieService.get('lang') || this.configService.defaultLang;
        // Re-check is user is logged in our authService
        // If not redirect to login page
        if (!this.loggedUser || !this.loggedUser._id) {
            this.router.navigate([this.lang, 'auth', 'login'], { queryParams: { returnUrl: state.url } });
            return false;
        }
        // Get requested permissions from app-routing config
        var requestedPermissions = route.data.permissions;
        // Optional: route open only to some role types (e.g. ['admin', 'operator']),
        // checked against the role the user is currently acting with
        var requestedRoleTypes = route.data.roleTypes;
        // Check is user's role is allowed
        if (this.hasAtLeastOnePermisson(requestedPermissions) && this.hasAllowedRoleType(requestedRoleTypes)) {
            return true;
        }
        // If we came here user is not allowed.
        // Redirect to 404 page an return false
        this.router.navigate([this.lang, 'errors', '400']);
        return false;
    };
    /**
     * Check if logged user has at least one of the permissions
     * which are requested to access to this route
     *
     * @since 1.0.0
     */
    RoleGuard.prototype.hasAtLeastOnePermisson = function (requestedPermissions) {
        var _this = this;
        // If item does not require permission, just return true
        if (!requestedPermissions || !requestedPermissions.length) {
            return true;
        }
        // Check if loggedUser has at least one of the requested permissions
        var found = requestedPermissions.some(function (perm) { return _this.loggedUserPermissions.indexOf(perm) >= 0; });
        return found;
    };
    /**
     * Check if the requested role type is one of those allowed on the route.
     * Routes without `data.roleTypes` keep allowing every role type.
     */
    RoleGuard.prototype.hasAllowedRoleType = function (requestedRoleTypes) {
        if (!requestedRoleTypes || !requestedRoleTypes.length) {
            return true;
        }
        var roleType = this.authService.loggedUserRequestedRoleType$.value;
        return !!roleType && requestedRoleTypes.indexOf(roleType) >= 0;
    };
    RoleGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function RoleGuard_Factory() { return new RoleGuard(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i2.AuthService), i0.ɵɵinject(i3.CookieService), i0.ɵɵinject(i4.ConfigService)); }, token: RoleGuard, providedIn: "root" });
    return RoleGuard;
}());
export { RoleGuard };
